<template>
  <div class="plan-order">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title"/>
    <studyplan-order-info @submit="submit" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Body from '@/mixins/body';
import StudyPlanorderComponents from './components'
const componentName = 'studyplan-order'
import { toast, throttle } from '@/utils'
import { setShareData } from '../options'
export default {
  name: componentName,
  componentName,
  mixins: [Body],
  components: {
    ...StudyPlanorderComponents
  },
  data() {
    return {
      title: '友邻学院'
    }
  },
  computed: {
    ...mapGetters('goods-studyplan/plan', [
      'selectedPlan',
      'termApplyResult'
    ])
  },
  created() {
    const { id } = this.$route.params
    this.$store.commit('goods-studyplan/plan/getTermApplyResult', { id })
    // 有已报名结果时刷新
    if (this.termApplyResult.joinValid === false) {
      if (!this.termApplyResult.userTermId) {
        toast(this.termApplyResult.message)
      } else {
        this.goSuccessView(id)
      }
    }
  },
  activated() {
    const { goodsId, goodsName } = this.selectedPlan
    this.title = goodsName // || '友邻学院'

    // 空页面回跳
    if (goodsId == null) {
      this.$router.replace({ path: `/goods-studyplan` })
    }
  },
  methods: {
    // 设置分享地址
    setShareData,
    submit: throttle(function(form) {
      const toView = (item) => {
        if (item.do_joinValid === true) {
          this.goSuccessView()
        } else {
          const { userPlanName: planName } = item
          if (planName) {
            toast(item.message)
          }
        }
      }
      this.$store.dispatch('goods-studyplan/plan/joinTerm', form)
        .then(toView)
        .catch(toView)
    }, 2000, { leading: true }),
    goSuccessView() {
      const { id } = this.$route.params
      this.$router.replace({ path: `/goods-studyplan-success/${id}` })
    }
  }
}
</script>

<style lang="scss">
.body-studyplan-order {
  background-color: #212B2EFF;
}
</style>